export default __webpack_public_path__ + "static/B0060-691ec9c5d9b8f3a3f51c1438d1411ab9.png";